export default __webpack_public_path__ + "static/media/Paws_up_teckstack.8a668d6e.jpg";